// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_1IJxS","button":"_2enUF","close":"_2DuAt"};